<mat-toolbar color="primary" id="avtale-godta-lisensbetingelser-dialog-tittel">
  {{ 'Tjenesteavtale'|translate }}
</mat-toolbar>
<mat-dialog-content>
  @if (laster()) {
    <div class="laster">
      <mat-progress-spinner mode="indeterminate" diameter="50"/>
      <p>{{'Henter betingelser'|translate}}</p>
    </div>
  } @else {
    <span [innerHTML]="betingelser()" class="betingelsertekst" data-testid="betingelsertekst"></span>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <div class="handlinger">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="godta()" [disabled]="laster()">
      {{ "Jeg aksepterer avtalen"|translate }}
    </button>
  </div>
  <button mat-button type="button" (click)="skrivUt()">{{ "Skriv ut"|translate }}</button>
</mat-dialog-actions>
